import { Injectable, signal } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrandConfigService {

  public brandConfigResolved = signal<boolean>(false);
  public brandConfigResolved$ = new ReplaySubject<boolean>(1);

}
